import React from 'react';

import * as S from './IncentiveBalance.styles';

const IncentiveBalance = ({
  heading,
  subHeading,
  price,
}) => {
  return (
    <S.InctBalance>
      <S.InctBalanceLeft>
        {heading && <S.InctBalanceHeading>{heading}</S.InctBalanceHeading>}
        {subHeading && <S.InctBalanceSubHeading>{subHeading}</S.InctBalanceSubHeading>}
      </S.InctBalanceLeft>
      {
        price &&
        <S.InctBalanceRight>
          <S.InctBalancePrice>{price}</S.InctBalancePrice>
        </S.InctBalanceRight>
      }
    </S.InctBalance>
  )
}

export default IncentiveBalance;